import React from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '~/redux/root-reducer';
import {MAMMOGRAM_BREAST_ULTRASOUND_TEST_KEYS} from '~/constants/medical-questionnaires';
import Questionnaire1Screen from '~/pages/homes/mammogram-breast-ultrasound-test/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/mammogram-breast-ultrasound-test/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/mammogram-breast-ultrasound-test/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/mammogram-breast-ultrasound-test/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/mammogram-breast-ultrasound-test/Questionnaire5Screen';
import {trackPageViewGA} from '~/services/google-analytics';

const MammogramBreastUltrasoundTest = () => {
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case MAMMOGRAM_BREAST_ULTRASOUND_TEST_KEYS.START:
        trackPageViewGA('/mammogram-breast-ultrasound-test/start', 'MDQ-Mammogram Breast Ultrasound Test - Start');
        return <Questionnaire1Screen />;
      case MAMMOGRAM_BREAST_ULTRASOUND_TEST_KEYS.PROFILE:
        trackPageViewGA('/mammogram-breast-ultrasound-test/profile', 'MDQ-Mammogram Breast Ultrasound Test - Profile');
        return <Questionnaire2Screen />;
      case MAMMOGRAM_BREAST_ULTRASOUND_TEST_KEYS.INVALID:
        trackPageViewGA('/mammogram-breast-ultrasound-test/invalid', 'MDQ-Mammogram Breast Ultrasound Test - Invalid');
        return <Questionnaire3Screen />;
      case MAMMOGRAM_BREAST_ULTRASOUND_TEST_KEYS.APPOINTMENT_PREFERENCES:
        trackPageViewGA(
          '/mammogram-breast-ultrasound-test/appointment-preferences',
          'MDQ-Mammogram Breast Ultrasound Test - Appointment Preferences',
        );
        return <Questionnaire4Screen />;
      case MAMMOGRAM_BREAST_ULTRASOUND_TEST_KEYS.YOUR_TEST_PACKAGE:
        trackPageViewGA(
          '/mammogram-breast-ultrasound-test/your-test-package',
          'MDQ-Mammogram Breast Ultrasound Test - Your Test Package',
        );
        return <Questionnaire5Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <Questionnaire1Screen />;
    }
  };

  return renderQuestion();
};

export default MammogramBreastUltrasoundTest;
